import { Routes } from '@angular/router';
import { AdminLayoutComponent, RouteInfo } from '@ov-suite/ui';
import { FeatureKey } from '@ov-suite/helpers-shared/lib/feature.enum';

export const angularRoutes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: 'flowable',
        loadChildren: () => import('./modules/process-definition/process-definition.module').then(m => m.ProcessDefinitionModule),
      },
      {
        path: 'inventory',
        loadChildren: () => import('./modules/inventory/inventory.module').then(m => m.InventoryModule),
      },
      {
        path: 'inventory-product',
        loadChildren: () => import('./modules/inventory-product-sku/inventory-product-sku.module').then(m => m.InventoryProductSkuModule),
      },
      {
        path: 'inventory-locations',
        loadChildren: () => import('./modules/inventory-location/inventory-location.module').then(m => m.InventoryLocationModule),
      },
      {
        path: 'process-definitions',
        loadChildren: () => import('./modules/process-definition/process-definition.module').then(m => m.ProcessDefinitionModule),
      },
      {
        path: 'workflow-processes',
        loadChildren: () => import('./modules/workflow-process/workflow-process.module').then(m => m.WorkflowProcessModule),
      },
      {
        path: 'load-allocation',
        loadChildren: () => import('./modules/load-allocation/load-allocation.module').then(m => m.LoadAllocationModule),
      },
      {
        path: 'wave-allocation',
        loadChildren: () => import('./modules/wave-allocation/wave-allocation.module').then(m => m.WaveAllocationModule),
      },
      {
        path: 'waves',
        loadChildren: () => import('./modules/waves/waves.module').then(m => m.WavesModule),
      },
      {
        path: 'vehicles',
        loadChildren: () => import('./modules/vehicles/vehicles.module').then(m => m.VehiclesModule),
      },
      {
        path: 'master-route',
        loadChildren: () => import('./modules/master-route/master-route.module').then(m => m.MasterRouteModule),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'exceptions',
        loadChildren: () => import('./modules/exception-log/exception-log.module').then(m => m.ExceptionLogModule),
      },
      {
        path: 'container-events',
        loadChildren: () =>
          import('./modules/pallet-audit-trail-events/inventory-container-events.module').then(m => m.InventoryContainerEventsModule),
      },
      {
        path: 'inventory-container',
        loadChildren: () => import('./modules/inventory-container/inventory-container.module').then(m => m.InventoryContainerModule),
      },
      {
        path: 'order',
        loadChildren: () => import('./modules/orders/order.module').then(m => m.OrderModule),
      },
      {
        path: 'order-events',
        loadChildren: () =>
          import('./modules/orders-audit-trail-events/orders-audit-trail-event.module').then(m => m.OrdersAuditTrailEventModule),
      },
      {
        path: 'notifications',
        loadChildren: () => import('@ov-suite/services-angular').then(m => m.NotificationsListModule),
      },
      {
        path: 'load-management',
        loadChildren: () => import('./modules/load-management/load-management.module').then(m => m.LoadManagementModule),
      },
      {
        path: 'picks',
        loadChildren: () => import('./modules/picks/picks.module').then(m => m.PicksModule),
      },
    ],
  },
];

export const sidebarRoutes: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'dashboard',
    icontype: 'fa fa-pie-chart',
    type: 'link',
  },
  {
    path: '/',
    title: 'Load Setup',
    type: 'sub',
    collapse: 'loading-management',
    icontype: 'fa fa-tasks',
    children: [
      { path: 'waves', title: 'Picking Waves', ab: 'PW', permissionId: FeatureKey.PICKING_WAVES },
      { path: 'vehicles', title: 'Vehicles', ab: 'V', permissionId: FeatureKey.VEHICLE_RESOURCES },
      // { path: 'master-route', title: 'Routes', ab: 'R', permissionId: FeatureKey.ROUTES },
    ],
  },
  {
    path: '/',
    title: 'Load Planning',
    type: 'sub',
    collapse: 'loading-planning',
    icontype: 'fa fa-calendar-minus-o',
    children: [
      { path: 'load-allocation', title: 'Load Allocation', ab: 'LA', permissionId: FeatureKey.LOAD_ALLOCATION },
      { path: 'wave-allocation', title: 'Wave Allocation', ab: 'WA', permissionId: FeatureKey.WAVE_ALLOCATION },
      { path: 'load-management', title: 'Load Management', ab: 'LM', permissionId: FeatureKey.WAVE_ALLOCATION },
      { path: 'order', title: 'Orders', ab: 'O', permissionId: FeatureKey.WAVE_ALLOCATION },
    ],
  },
  {
    path: '/',
    title: 'Inventory',
    type: 'sub',
    collapse: 'inventory',
    icontype: 'fa fa-plus-circle',
    children: [
      // { path: 'inventory', title: 'Inventory List', ab: 'I', permissionId: FeatureKey.INVENTORY_LIST },
      { path: 'inventory-locations', title: 'Inventory Levels', ab: 'ILV', permissionId: FeatureKey.INVENTORY_PRODUCT },
    ],
  },
  {
    path: '/',
    title: 'Monitoring',
    type: 'sub',
    collapse: 'monitoring',
    icontype: 'fa fa-tachometer',
    children: [
      { path: 'picks', title: 'Picks', ab: 'P', permissionId: FeatureKey.PICKING_WAVES },
      { path: 'exceptions', title: 'Exceptions', ab: 'E', permissionId: FeatureKey.EXCEPTIONS },
      { path: 'order-events', title: 'Order Events', ab: 'OE', permissionId: FeatureKey.EXCEPTIONS },
      { path: 'container-events', title: 'Pallet Events', ab: 'PE', permissionId: FeatureKey.EXCEPTIONS },
      // { path: 'process-definitions', title: 'Process Definitions', ab: 'PD', permissionId: FeatureKey.PROCESS_DEFINITIONS },
      // { path: 'workflow-processes', title: 'Workflow Processes', ab: 'WP', permissionId: FeatureKey.WORKFLOW_PROCESSES },
    ],
  },
];
